import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { techAchievements } from '@/mocks/evidence';

export default function TechAchievements() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="技术成果"
            title="核心技术交付成果"
            subtitle="TOMA 智能体、数字货架、ePin 数字身份与智能清分，构成华辉数智的核心技术成果。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {techAchievements.map((t, i) => (
            <Reveal key={t.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${t.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{t.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}